import { useContext, useEffect, useState } from "react";
import { BarChart3, Download, Eye, FileText, Loader, Loader2 } from "lucide-react";
import { BatchSummary } from "./SummaryGrid";
import { Run } from "./KanTimeDetails";
import { Button } from "./ui/button";
import { DataTable } from "./DataTable";
import { Layout } from "./Layout";
import { Card, CardContent, CardHeader } from "./ui/card";
import { BreadcrumbHeader } from "./BreadCrumbNavigation";
import { AppContext } from "../src/App"
import { PaginationCustom } from "./ui/pagination-custom";
import { useAuth } from "./AuthContext";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { apiClient } from "@/Utils/apiClient";
import { toast } from "sonner";
import { CircularLoader } from "./ui/SkeletonLoader";
import { buildQuery } from "@/Utils/helpers";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "@/routes/config";
// import { Run } from "./KanTimeDetails"
interface Summary {
    other_count: number;
    dls_count: number;
    csc_count: number;
    no_action_charts: number;
    pending_charts: number;
    updated_charts: number;
    total_charts: number;
    updateTime: string
}
interface ChartData {
    chart_id: number;
    chart_type: number;
    client_name: number;
    client_id: number;
    visit_date: number;
    check_in_time: number;
    update_status: string;
    success: number;
    level: number;
    message: ChartLog[]
}
interface ChartLog {
    created_at: string;
    chart_id: number;
    level: string;
    message: string;
    timestamp?: String;
}
interface ChartDetail {
    data: {
        summary: Summary
        chartsData: ChartData[]
        executionLogs: ChartLog[]
        ktlogs: ChartLog[]
    }
    pagination: {
        limit: number;
        totalCount: number;
        totalPages: number;
        currentPage: number;


    }
}
export function KanTimeRunLogView() {
    const { setCurrentView, selectedHarvestRunData, setSelectedHarvestRunData, orgConfig } = useContext(AppContext);
    const { token } = useAuth()
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState<ChartDetail>()
    const [selectedChart, setSelectedChart] = useState<ChartData>();
    const [showChartLogs, setShowChartLogs] = useState(false);
    const itemsPerPage = 15;
    const navigate = useNavigate();
    const location = useLocation();
    const parseLogData = location.state.kantime;
    const [isFetchingLogs, setIsFetchingLogs] = useState(false);

    useEffect(() => {
        if (!selectedHarvestRunData) {
            setSelectedHarvestRunData(parseLogData);
        }
    }, [])

    const thStyle = "text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]";
    const fetchData = async () => {
        console.log("fetchdata selectedharvestrundatya", selectedHarvestRunData)
        if (!selectedHarvestRunData) {
            return
        }
        try {
            const updatedDate = new Date(selectedHarvestRunData.log_date).toISOString().split("T")[0]
            const queryParams = {
                page: currentPage,
                limit: itemsPerPage
            }
            const query = buildQuery(queryParams, {
                page: "page",
                limit: "limit"
            })
            const response = await apiClient(`audits/charts/kantime/update/logs/${updatedDate}?${query}`, {
                method: "GET",
                token
            })
            const result = await response.json();
            //     if(!result?.success){
            //     throw new Error(result?.error)
            //   }

            result.data.summary.updateTime = selectedHarvestRunData.log_date
            setData(result);
        }
        catch (error: any) {
            if (error.status < 500) {
                toast.error(error.message);
            }
            else {
                toast.error("Something went wrong please try again");
            }

        }

    }
    useEffect(() => {
        fetchData()
        // setCurrentPage(1)
    }, [currentPage, selectedHarvestRunData])
    const fetchChartLog = async (chart: ChartData) => {
        setIsFetchingLogs(true);
        try {
            const query = buildQuery({ chartId: chart.chart_id }, {
                chartId: "chartId"
            })
            const response = await apiClient(`audits/charts/kantime/update/logs?${query}`, {
                method: 'GET',
                token
            });
            const result = await response.json();
            console.log(result, "2345677")
            if (!result.success) {
                throw new Error(result.error)
            }
            setSelectedChart(prev => ({
                ...prev!,
                message: result?.data?.executionLogs
            }))

        }
        catch (err) {
            toast.error("Failed to fetch logs"); // Good practice to notify user
        } finally {
            setIsFetchingLogs(false);
        }
    }

    const handleLogDownload = async () => {
        const date = new Date(selectedHarvestRunData.log_date).toISOString().split("T")[0]
        if (!date) {
            toast.error("Cannot download log, run name is missing.");
            return;
        }

        try {

            const response = await apiClient(`audits/charts/kantime/update/logs/${date}/download`, {
                method: 'GET',
                token
            });

            if (!response.ok) {
                const errText = await response.text(); // read raw
                try {
                    const errJson = JSON.parse(errText);
                    throw new Error(errJson.error || "Failed to download log");
                } catch {
                    throw new Error("Failed to download log");
                }
            }

            // Success → read as blob
            const blob = await response.blob();

            const filename = `${date}.txt`;

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

        } catch (error: any) {
            console.error("Download error:", error);
            toast.error(error.message || "Could not download log.");
        }
    };
    //pagination
    const totalPages = data?.pagination?.totalPages || Math.ceil(data?.data?.chartsData?.length || 0 / itemsPerPage) || 0;
    const totalItems = data?.pagination?.totalCount || data?.data?.chartsData?.length || 0;

    // Fix: Use currentPage.currentPage instead of currentPage
    // const startIndex = (currentPage.currentPage - 1) * itemsPerPage;
    // why here we use paginated we get all charts in single API so we use pagnitated
    // const paginatedData = currentPage.totalItems?.slice(startIndex, startIndex + itemsPerPage);
    const getStatusColor = (status: string) => {
        switch (status) {
            case 'Updated': return 'bg-green-100 text-green-800 p-1 rounded text-sm';
            case 'No Action': return 'bg-red-100 text-red-800 p-1 rounded text-sm';
            case 'Pending': return 'bg-amber-100 text-amber-800 p-1 rounded text-sm';
            default: return 'bg-gray-100 text-gray-800 p-1 rounded text-sm';
        }
    };
    // const handleSelectedChart=async(chart:ChartData)=>{

    // }
    return (
        <Layout>
            <div className="min-h-screen bg-gray-50">

                <div className="p-6 space-y-6">
                    <div>
                        <BreadcrumbHeader
                            title={`${orgConfig?.name} Updated Charts Log`}   // 👈 Dynamic page title
                            breadcrumbs={[
                                {
                                    label: `${orgConfig?.name} Status`, onClick: () => {
                                        setCurrentView('kanTime-details');
                                        navigate(-1);
                                    }
                                },
                                { label: `${orgConfig?.name} Updated Charts Log` },
                            ]}
                            onBack={() => {
                                setCurrentView('kanTime-details');
                                navigate(-1);
                            }}
                        />

                    </div>
                    {!data?.data ? <CircularLoader size={60} message="Fetching Charts Details" /> : <>

                        <div>
                            {data?.data?.summary && <BatchSummary<Summary>
                                run={data?.data?.summary}
                                columns={3}
                                title="Updated Charts Summary"
                                icon={<BarChart3 className="w-5 h-5 text-green-600" />}
                                headerClassName="flex items-center gap-2 mb-4 "
                                titleClassName="text-xl font-bold "
                                fields={[
                                    {
                                        key: "updateTime",
                                        label: "Updated At",
                                        render: (value, run) => (
                                            <>
                                                <span>{new Date(value).toLocaleDateString("en-US")}</span><br />
                                                <span className="text-gray-500 text-xs font-inter">Time: <span className="text-gray-500 text-xs">{new Date(value).toLocaleTimeString("en-US")}</span></span>

                                                {/* <div className="flex gap-1 mt-2">
            <Badge className="text-xs bg-blue-100 text-blue-700">{run.run_type}</Badge>
            <Badge className="text-xs bg-purple-100 text-purple-700">{run.chart_type}</Badge>
          </div> */}
                                            </>
                                        ),
                                    },
                                    { key: "dls_count", label: "No of DLS Charts" },
                                    { key: "csc_count", label: "No of CSC Charts" },
                                    { key: "updated_charts", label: "Updated", className: "text-green-600" },
                                    { key: "pending_charts", label: "Pending", className: "text-yellow-600" },
                                    { key: "no_action_charts", label: "No Action", className: "text-red-600" },

                                ]}
                            />}

                        </div>
                        <div>
                            <div>

                                <div className="flex items-center gap-2 mb-4">
                                    <FileText className="w-5 h-5 text-gray-600" />
                                    <h2 className="text-xl font-semibold text-gray-900">Charts ({data?.pagination?.totalCount})</h2>
                                </div>

                                {data?.data?.chartsData && <DataTable<ChartData>
                                    data={data?.data?.chartsData}
                                    columns={[
                                        {
                                            key: "chart_id",
                                            header: "Chart ID",
                                            headerClassName: thStyle,
                                            cellClassName: "font-inter text-sm text-gray-700",
                                            render: (chart) => chart.chart_id,
                                        },
                                        {
                                            key: "client_id",
                                            header: "Client ID",
                                            headerClassName: thStyle,
                                            cellClassName: "font-inter text-sm text-gray-700",
                                            render: (chart) => chart.client_id,
                                        },
                                        {
                                            key: "client_name",
                                            header: "Client Name",
                                            headerClassName: thStyle,
                                            cellClassName: "font-inter text-sm text-gray-700",
                                            render: (chart) => chart.client_name,
                                        },
                                        {
                                            key: "visit_date",
                                            header: "Visit Date",
                                            headerClassName: thStyle,
                                            render: (chart) =>
                                                chart.visit_date
                                                    ? new Date(chart.visit_date).toLocaleDateString("en-US")
                                                    : "-",
                                            cellClassName: "font-inter text-sm text-gray-700",
                                        },
                                        {
                                            key: "chart_type",
                                            header: "Chart Type",
                                            headerClassName: thStyle,
                                            render: (chart) => chart.chart_type,
                                            cellClassName: "font-inter text-sm text-gray-700",
                                        },
                                        {
                                            key: "update_status",
                                            header: "Status",
                                            headerClassName: thStyle,
                                            render: (chart) => (<span className={getStatusColor(chart.update_status)}>{chart.update_status}</span>),
                                            cellClassName: "font-inter text-sm text-gray-700",
                                        },
                                        {
                                            key: "action",
                                            header: "Action",
                                            headerClassName: thStyle,
                                            render: (chart) => (
                                                <div className="flex items-center gap-1">
                                                    <Button
                                                        variant="ghost"
                                                        size="sm"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            // handleRunClick(chart);
                                                            setSelectedChart(chart);
                                                            fetchChartLog(chart)
                                                            setShowChartLogs(true);



                                                        }}
                                                        title="View Details"
                                                    >
                                                        <Eye className="w-4 h-4" />
                                                    </Button>
                                                </div>
                                            ),
                                        },
                                    ]}
                                />}


                            </div>
                        </div>
                        {totalPages > 1 && (
                            <div className="flex items-center justify-between px-6 py-4 border-t">
                                <PaginationCustom
                                    currentPage={currentPage}      // your local state
                                    totalPages={totalPages}                    // calculated total pages
                                    totalItems={totalItems} // total items in your data
                                    itemsPerPage={itemsPerPage}                // page size
                                    onPageChange={(page) => {
                                        setCurrentPage(page);
                                        // setCurrentPageHarvestRuns(page); // keep your extra update
                                    }}
                                    onItemsPerPageChange={(size) => {
                                        // If you want itemsPerPage to be dynamic
                                        // setItemsPerPage(itemsPerPage);   //from dropdown if user select how many records needs to show then enable it
                                        setCurrentPage(1);
                                        // setCurrentPageHarvestRuns(1);
                                    }}
                                // pageSizeOptions={[10, 25, 50]}   // optional customization
                                // showPageSizeSelector={false}     // hide dropdown since your inline didn’t use it
                                // showItemCount={true}             // keep "Showing X to Y of Z"
                                />
                            </div>
                        )}
                        <div>
                            <div>
                                <div className="flex items-center justify-between mb-2">
                                    <div className="flex items-center gap-2">
                                        <FileText className="w-5 h-5 text-gray-600" />
                                        <h2 className="text-xl font-semibold text-gray-900">Execution Log</h2>
                                    </div>
                                    <Button
                                        variant="ghost"
                                        size="lg"
                                        onClick={() => {
                                            handleLogDownload();
                                        }}
                                        title="Download Execution Log" // Changed title slightly
                                        className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors me-4"
                                    >
                                        <Download className="w-5 h-5" />
                                    </Button>

                                </div>
                                <p className="text-sm text-gray-600 mb-4">Recent updated charts logs</p>
                            </div>
                            <div>
                                <div className="bg-gray-900 text-white p-3 rounded-lg font-mono text-sm max-h-64 overflow-y-auto">
                                    <div className="space-y-1">
                                        {data?.data?.ktlogs && data?.data?.ktlogs.length > 0 ? data?.data?.ktlogs?.map((log, index) => (
                                            <div key={index} className="text-gray-400">

                                                {"[" + log?.timestamp + "]" + " " + log?.level + ":" + " " + log?.message}
                                                {/* {(log.created_at && log.level && log.message)
  ? `[${log.created_at}] ${log.level}: ${log.message}`
  : JSON.stringify(log)} */}

                                            </div>
                                        )) : "No Logs Found"}
                                    </div>
                                </div>

                            </div>
                        </div></>}


                </div>

                <Dialog open={showChartLogs} onOpenChange={setShowChartLogs}>
                    <DialogContent className="sm:max-w-4xl w-full max-h-[80vh]">
                        <DialogHeader>
                            <DialogTitle>{`Log for Updated Chart ID: ${selectedChart?.chart_id}`}</DialogTitle>
                            <DialogDescription>
                                Updation logs
                            </DialogDescription>
                        </DialogHeader>
                        <div className="bg-gray-900 text-white p-3 rounded-lg font-mono text-sm max-h-64 overflow-y-auto">
                            {isFetchingLogs ? (
                                <div className="flex justify-center items-center h-20 text-gray-400">
                                    <Loader2 size={30} className="animate-spin" />

                                </div>
                            ) : (
                                <div className="space-y-1">
                                    {selectedChart?.message && selectedChart?.message?.length > 0 ? (
                                        selectedChart?.message?.map((log, index) => (
                                            <div key={index} className="text-green-400">
                                                {(log.created_at && log.level && log.message)
                                                    ? `[${log.created_at}] ${log.level}: ${log.message}`
                                                    : JSON.stringify(log)}
                                            </div>
                                        ))
                                    ) : (
                                        <div >No Logs Found</div>
                                    )}
                                </div>
                            )}
                        </div>


                    </DialogContent>
                </Dialog>

            </div>

        </Layout>
    );
}